module.exports = __webpack_public_path__ + "static/media/alert.33342228.svg";